/**
 * Formats a number to a currency string in EUR with a thousands separator and two decimal places.
 * @param number
 * @returns {string}
 */
export const toCurrencyShort = (number) => {
    return parseFloat(Math.round(number * 100) / 100)
        .toFixed(2)
        .replace('.', ',')
        .replace(',00', ',-');
};

/**
 * Formats a number to a currency string in EUR with a thousands separator and two decimal places.
 * Rounded numbers are displayed with a comma and a hyphen (not ,00).
 * @param number
 * @returns {`€ ${string}`}
 */
export const toCurrencyShortEur = (number) => {
    return `€\xa0${parseFloat(Math.round(number * 100) / 100)
        .toFixed(2)
        .replace('.', ',')
        .replace(',00', ',-')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.') // add thousands separator
    }`;
};

/**
 * Formats a number to a currency string in EUR with thousands separator and no decimal places.
 * @param number
 * @returns {`€ ${string}`}
 */
export const toCurrencyEurRounded = (number) => {
    return `€\xa0${parseFloat(Math.round(number))
        .toFixed(0)
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.') // add thousands separator
    }`;
};
